export default __webpack_public_path__ + "img/7a6d2c5f484cdd329d871a2d6c42998f.png";